enum ProcessRequestResult {
    SUCCESS = 'SUCCESS',
    SUCCESS_NO_CHILDREN = 'SUCCESS_NO_CHILDREN',
    SUCCESS_WAITING = 'SUCCESS_WAITING',
    PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
    FAILED = 'FAILED',
    FAILED_IN_SUCCESS_AFTER_EXECUTION = 'FAILED_IN_SUCCESS_AFTER_EXECUTION',
    FAILED_EXPIRED = 'FAILED_EXPIRED'
}

export default ProcessRequestResult;